export { default as SerpStoreOpenSlot } from './SerpStoreOpenSlot';
